export default __webpack_public_path__ + "static/project-slide-2-1640-765-e49397d724b4d378046c1c5e468878a3.jpg";